module.exports = __webpack_public_path__ + "img/c542aad.png";